export const USER_LOGOUT_START = 'USER_LOGOUT_START';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_FAILED = 'USER_LOGOUT_FAILED';
export const GET_USER_PROFILE_START = 'GET_USER_PROFILE_START';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_FAILED = 'GET_USER_PROFILE_FAILED';
export const USER_PROFILE_UPDATE_START = 'USER_PROFILE_UPDATE_START';
export const USER_PROFILE_UPDATE_SUCCESS = 'USER_PROFILE_UPDATE_SUCCESS';
export const USER_PROFILE_UPDATE_FAILED = 'USER_PROFILE_UPDATE_FAILED';
export const CHANGE_ACTIVE_STORE_START = 'CHANGE_ACTIVE_STORE_START';
export const CHANGE_ACTIVE_STORE_SUCCESS = 'CHANGE_ACTIVE_STORE_SUCCESS';
export const CHANGE_ACTIVE_STORE_FAILED = 'CHANGE_ACTIVE_STORE_FAILED';

export const CREDIT_BALANCE_START = 'CREDIT_BALANCE_START';
export const CREDIT_BALANCE_SUCCESS = 'CREDIT_BALANCE_SUCCESS';
export const CREDIT_BALANCE_FAILED = 'CREDIT_BALANCE_FAILED';
export const CREDIT_HISTORY_START = 'CREDIT_HISTORY_START';
export const CREDIT_HISTORY_SUCCESS = 'CREDIT_HISTORY_SUCCESS';
export const CREDIT_HISTORY_FAILED = 'CREDIT_HISTORY_FAILED';

export const GET_USER_CREDIT_CARDS_START = 'GET_USER_CREDIT_CARDS_START';
export const GET_USER_CREDIT_CARDS_SUCCESS = 'GET_USER_CREDIT_CARDS_SUCCESS';
export const GET_USER_CREDIT_CARDS_FAILED = 'GET_USER_CREDIT_CARDS_FAILED';

export const REPLACE_USER_CREDIT_CARD_START = 'REPLACE_USER_CREDIT_CARD_START';
export const REPLACE_USER_CREDIT_CARD_SUCCESS = 'REPLACE_USER_CREDIT_CARD_SUCCESS';
export const REPLACE_USER_CREDIT_CARD_FAILED = 'REPLACE_USER_CREDIT_CARD_FAILED';

export const DELETE_USER_CREDIT_CARD_START = 'DELETE_USER_CREDIT_CARD_START';
export const DELETE_USER_CREDIT_CARD_SUCCESS = 'DELETE_USER_CREDIT_CARD_SUCCESS';
export const DELETE_USER_CREDIT_CARD_FAILED = 'DELETE_USER_CREDIT_CARD_FAILED';

export const GET_TIER_SUBSCRIPTION_PLANS_START = 'GET_TIER_SUBSCRIPTION_PLANS_START';
export const GET_TIER_SUBSCRIPTION_PLANS_SUCCESS = 'GET_TIER_SUBSCRIPTION_PLANS_SUCCESS';
export const GET_TIER_SUBSCRIPTION_PLANS_FAILED = 'GET_TIER_SUBSCRIPTION_PLANS_FAILED';

export const CREATE_SUBSCRIPTION_TIER_START = 'CREATE_SUBSCRIPTION_TIER_START';
export const CREATE_SUBSCRIPTION_TIER_SUCCESS = 'CREATE_SUBSCRIPTION_TIER_SUCCESS';
export const CREATE_SUBSCRIPTION_TIER_FAILED = 'CREATE_SUBSCRIPTION_TIER_FAILED';

export const UPDATE_SUBSCRIPTION_TIER_START = 'UPDATE_SUBSCRIPTION_TIER_START';
export const UPDATE_SUBSCRIPTION_TIER_SUCCESS = 'UPDATE_SUBSCRIPTION_TIER_SUCCESS';
export const UPDATE_SUBSCRIPTION_TIER_FAILED = 'UPDATE_SUBSCRIPTION_TIER_FAILED';

export const DELETE_SUBSCRIPTION_TIER_START = 'DELETE_SUBSCRIPTION_TIER_START';
export const DELETE_SUBSCRIPTION_TIER_SUCCESS = 'DELETE_SUBSCRIPTION_TIER_SUCCESS';
export const DELETE_SUBSCRIPTION_TIER_FAILED = 'DELETE_SUBSCRIPTION_TIER_FAILED';

export const EDIT_USER_SUBSCRIPTION_PLAN = 'EDIT_USER_SUBSCRIPTION_PLAN';
export const CANCEL_EDIT_USER_SUBSCRIPTION_PLAN = 'CANCEL_EDIT_USER_SUBSCRIPTION_PLAN';

export const UPDATE_USER_SUBSCRIPTION_PLAN_START = 'UPDATE_USER_SUBSCRIPTION_PLAN_START';
export const UPDATE_USER_SUBSCRIPTION_PLAN_SUCCESS = 'UPDATE_USER_SUBSCRIPTION_PLAN_SUCCESS';
export const UPDATE_USER_SUBSCRIPTION_PLAN_FAILED = 'UPDATE_USER_SUBSCRIPTION_PLAN_FAILED';

export const UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_START = 'UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_START';
export const UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_SUCCESS = 'UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_SUCCESS';
export const UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_FAILED = 'UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_FAILED';

export const CREATE_CUSTOMER_ACCOUNT_START = 'CREATE_CUSTOMER_ACCOUNT_START';
export const CREATE_CUSTOMER_ACCOUNT_SUCCESS = 'CREATE_CUSTOMER_ACCOUNT_SUCCESS';
export const CREATE_CUSTOMER_ACCOUNT_FAILED = 'CREATE_CUSTOMER_ACCOUNT_FAILED';

export const REQUEST_TAX_RATES_CONFIGURATIONS_START = 'REQUEST_TAX_RATES_CONFIGURATIONS_START';
export const REQUEST_TAX_RATES_CONFIGURATIONS_SUCCESS = 'REQUEST_TAX_RATES_CONFIGURATIONS_SUCCESS';
export const REQUEST_TAX_RATES_CONFIGURATIONS_FAILED = 'REQUEST_TAX_RATES_CONFIGURATIONS_FAILED';

export const BUY_SUBSCRIPTION_ADDON_START = 'BUY_SUBSCRIPTION_ADDON_START';
export const BUY_SUBSCRIPTION_ADDON_SUCCESS = 'BUY_SUBSCRIPTION_ADDON_SUCCESS';
export const BUY_SUBSCRIPTION_ADDON_FAILED = 'BUY_SUBSCRIPTION_ADDON_FAILED';

export const GET_ACTIVE_STORE_USERS_START = 'GET_ACTIVE_STORE_USERS_START';
export const GET_ACTIVE_STORE_USERS_SUCCESS = 'GET_ACTIVE_STORE_USERS_SUCCESS';
export const GET_ACTIVE_STORE_USERS_FAILED = 'GET_ACTIVE_STORE_USERS_FAILED';

export const GET_STORE_USERS_EXPORT_START = 'GET_STORE_USERS_EXPORT_START';
export const GET_STORE_USERS_EXPORT_SUCCESS = 'GET_STORE_USERS_EXPORT_SUCCESS';
export const GET_STORE_USERS_EXPORT_FAILED = 'GET_STORE_USERS_EXPORT_SUCCESS';

export const USER_SIGNUP_ONELOGIN_START = 'USER_SIGNUP_ONELOGIN_START';
export const USER_SIGNUP_ONELOGIN_SUCCESS = 'USER_SIGNUP_ONELOGIN_SUCCESS';
export const USER_SIGNUP_ONELOGIN_FAILED = 'USER_SIGNUP_ONELOGIN_FAILED';

export const REFRESH_TOKEN_START = 'REFRESH_TOKEN_START';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_FAILED = 'REFRESH_TOKEN_FAILED';


export const userLogoutStart = () => ({
  type: USER_LOGOUT_START
});

export const userLogoutSuccess = (data) => ({
  type: USER_LOGOUT_SUCCESS,
  data
});

export const userLogoutFailed = (error) => ({
  type: USER_LOGOUT_FAILED,
  error
});

export const getUserProfileStart = () => ({
  type: GET_USER_PROFILE_START
});

export const getUserProfileSuccess = (data) => ({
  type: GET_USER_PROFILE_SUCCESS,
  data
});

export const getUserProfileFailed = (error) => ({
  type: GET_USER_PROFILE_FAILED,
  error
});

export const getCreditBalanceStart = () => ({
  type: CREDIT_BALANCE_START
});

export const getCreditBalanceSuccess = (data) => ({
  type: CREDIT_BALANCE_SUCCESS,
  data
});

export const getCreditBalanceFailed = (error) => ({
  type: CREDIT_BALANCE_FAILED,
  error
});

export const getCreditHistoryStart = () => ({
  type: CREDIT_HISTORY_START
});

export const getCreditHistorySuccess = (data) => ({
  type: CREDIT_HISTORY_SUCCESS,
  data
});

export const getCreditHistoryFailed = (error) => ({
  type: CREDIT_HISTORY_FAILED,
  error
});

export const getUserCreditCardsStart = () => ({
  type: GET_USER_CREDIT_CARDS_START
});

export const getUserCreditCardsSuccess = (data) => ({
  type: GET_USER_CREDIT_CARDS_SUCCESS,
  data
});

export const getUserCreditCardsFailed = (error) => ({
  type: GET_USER_CREDIT_CARDS_FAILED,
  error
});

export const replaceUserCreditCardStart = () => ({
  type: REPLACE_USER_CREDIT_CARD_START
});

export const replaceUserCreditCardSuccess = () => ({
  type: REPLACE_USER_CREDIT_CARD_SUCCESS
});

export const replaceUserCreditCardFailed = (error) => ({
  type: REPLACE_USER_CREDIT_CARD_FAILED,
  error
});

export const deleteUserCreditCardStart = () => ({
  type: DELETE_USER_CREDIT_CARD_START
});

export const deleteUserCreditCardSuccess = (id) => ({
  type: DELETE_USER_CREDIT_CARD_SUCCESS,
  id
});

export const deleteUserCreditCardFailed = (error) => ({
  type: DELETE_USER_CREDIT_CARD_FAILED,
  error
});

export const getTierSubscriptionPlansStart = () => ({
  type: GET_TIER_SUBSCRIPTION_PLANS_START
});

export const getTierSubscriptionPlansSuccess = (data) => ({
  type: GET_TIER_SUBSCRIPTION_PLANS_SUCCESS,
  data
});

export const getTierSubscriptionPlansFailed = (error) => ({
  type: GET_TIER_SUBSCRIPTION_PLANS_FAILED,
  error
});

export const createSubscriptionTierStart = () => ({
  type: CREATE_SUBSCRIPTION_TIER_START
});

export const createSubscriptionTierSuccess = (data) => ({
  type: CREATE_SUBSCRIPTION_TIER_SUCCESS,
  data
});

export const createSubscriptionTierFailed = (error) => ({
  type: CREATE_SUBSCRIPTION_TIER_FAILED,
  error
});

export const updateSubscriptionTierStart = () => ({
  type: UPDATE_SUBSCRIPTION_TIER_START
});

export const updateSubscriptionTierSuccess = (data) => ({
  type: UPDATE_SUBSCRIPTION_TIER_SUCCESS,
  data
});

export const updateSubscriptionTierFailed = (error) => ({
  type: UPDATE_SUBSCRIPTION_TIER_FAILED,
  error
});

export const deleteSubscriptionTierStart = () => ({
  type: DELETE_SUBSCRIPTION_TIER_START
});

export const deleteSubscriptionTierSuccess = (data, id) => ({
  type: DELETE_SUBSCRIPTION_TIER_SUCCESS,
  data,
  id
});

export const deleteSubscriptionTierFailed = (error) => ({
  type: DELETE_SUBSCRIPTION_TIER_FAILED,
  error
});

export const editUserSubscriptionPlan = (actionName, option, editedPlanId, editedPlanTierId) => ({
  type: EDIT_USER_SUBSCRIPTION_PLAN,
  actionName,
  option,
  editedPlanId,
  editedPlanTierId
});

export const cancelEditUserPlans = () => ({
  type: CANCEL_EDIT_USER_SUBSCRIPTION_PLAN
});

export const updateUserSubscriptionPlanStart = () => ({
  type: UPDATE_USER_SUBSCRIPTION_PLAN_START
});

export const updateUserSubscriptionPlanSuccess = (results, usersToUpdate) => ({
  type: UPDATE_USER_SUBSCRIPTION_PLAN_SUCCESS,
  results,
  usersToUpdate
});

export const updateUserSubscriptionPlanFailed = (error) => ({
  type: UPDATE_USER_SUBSCRIPTION_PLAN_FAILED,
  error
});

export const updateCurrentUserSubscriptionPlanStart = () => ({
  type: UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_START
});

export const updateCurrentUserSubscriptionPlanSuccess = (data) => ({
  type: UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_SUCCESS,
  data
});

export const updateCurrentUserSubscriptionPlanFailed = (error) => ({
  type: UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_FAILED,
  error
});

export const createCustomerAccountStart = () => ({
  type: CREATE_CUSTOMER_ACCOUNT_START
});

export const createCustomerAccountSuccess = (data) => ({
  type: CREATE_CUSTOMER_ACCOUNT_SUCCESS,
  data
});

export const createCustomerAccountFailed = (error) => ({
  type: CREATE_CUSTOMER_ACCOUNT_FAILED,
  error
});

export const requestTaxRatesConfigurationStart = () => ({
  type: REQUEST_TAX_RATES_CONFIGURATIONS_START
});

export const requestTaxRatesConfigurationSuccess = () => ({
  type: REQUEST_TAX_RATES_CONFIGURATIONS_SUCCESS
});

export const requestTaxRatesConfigurationFailed = (error) => ({
  type: REQUEST_TAX_RATES_CONFIGURATIONS_FAILED,
  error
});

export const updateUserProfileStart = () => ({
  type: USER_PROFILE_UPDATE_START
});

export const updateUserProfileSuccess = (data) => ({
  type: USER_PROFILE_UPDATE_SUCCESS,
  data
});

export const updateUserProfileFailed = (error) => ({
  type: USER_PROFILE_UPDATE_FAILED,
  error
});

export const changeActiveStoreStart = () => ({
  type: CHANGE_ACTIVE_STORE_START
});

export const changeActiveStoreSuccess = (data) => ({
  type: CHANGE_ACTIVE_STORE_SUCCESS,
  data
});

export const changeActiveStoreFailed = (error) => ({
  type: CHANGE_ACTIVE_STORE_FAILED,
  error
});

export const buySubscriptionPlanAddonStart = () => ({
  type: BUY_SUBSCRIPTION_ADDON_START
});

export const buySubscriptionPlanAddonSuccess = (data) => ({
  type: BUY_SUBSCRIPTION_ADDON_SUCCESS,
  data
});

export const buySubscriptionPlanAddonFailed = (error) => ({
  type: BUY_SUBSCRIPTION_ADDON_FAILED,
  error
});

export const getActiveStoreUsersStart = () => ({
  type: GET_ACTIVE_STORE_USERS_START
});

export const getActiveStoreUsersSuccess = (data) => ({
  type: GET_ACTIVE_STORE_USERS_SUCCESS,
  data
});

export const getActiveStoreUsersFailed = (error) => ({
  type: GET_ACTIVE_STORE_USERS_FAILED,
  error
});

export const userSignUpOneLoginStart = () => ({
  type: USER_SIGNUP_ONELOGIN_START
});

export const userSignUpOneLoginSuccess = (data) => ({
  type: USER_SIGNUP_ONELOGIN_SUCCESS,
  data
});

export const userSignUpOneLoginFailed = (error) => ({
  type: USER_SIGNUP_ONELOGIN_FAILED,
  error
});

export const refreshTokenStart = () => ({
  type: REFRESH_TOKEN_START
});

export const refreshTokenSuccess = (data) => ({
  type: REFRESH_TOKEN_SUCCESS,
  data
});

export const refreshTokenFailed = (error) => ({
  type: REFRESH_TOKEN_FAILED,
  error
});
